import { detectIncognito } from "detectincognitojs";


export const detect = async () => {
  const isIncognito = await detectIncognito();
  return isIncognito?.isPrivate;
};
